import { useReducer } from "react";
import { computeOptionStatus } from "../pages/service/serviceUtils";

const initialState = {
  isTesla:false,
  step: 0,
  stepStatus: 0,
  lockStepperNext: true,
  isAuthorizedEV: false,
  apiOptions: null,
  options: { standarizedService: false, bodyWork: false, tyresChange: false },
  optionsEligibility : { standarizedService: false, bodyWork: false, tyresChange: false },
  hasUsertouchedCheckboxes: false,
  currentMilleage: 0,
  mileageLimits: {
    standarizedService: 0,
    tyresChange: 0,
  },
  optionsComputed: {
    standarizedService: {},
    tyresChange: {},
    bodyWork: {},
  },
  serviceFlowId: 0,
  showServiceLightIndicatorNeeded: false,
  serviceLightIndicator: false,
  selectedPickup: false,
  stepTwoAvailableAppointments: {pickup:null, firstAvailable: null},
  stepThreeOptions: {
    pickupOptions:[],
    CRMOptions: [],
    availabilityOptions: [],
  },
  pickupCost: null,
  loyaltyCost: null,
  showInvoiceOption: false,
  hasSelectedInvoice: false,
  stepThree: "", // can be one of : 1) FirstAvailableAvis 2) NearestAvis , 3) PickupCRMForm, 4) PickupAvis 5) CRMForm 6) AuthorizedMap
  calendarData:[], // the incoming data from endpoint services
  calendarValues: { // the selected values for date and timeslot
    selectedDate: null,
    selectedSlots: [],
  },
  selectedGarage: null,
  pickupCRMFormAddress:{
    street:"",
    number:"",
    area:"",
    zipCode:"",
  },
  garageCalendarData:[], // the incoming data when they are paired withe garages (mainly for the pickup page and the garage availability list to feed the proper calendar data per garage)
  standarizedService: {additionalComments : ""},
  tyresChange: {
    frontTyreWidth:234,
    frontTyreHeight:55,
    frontTyreDiameter:17,
    rearTyreWidth:234,
    rearTyreHeight:55,
    rearTyreDiameter:17,
    tyreRunFlat:false,
    rearSameAsFront:true,
  },
  bodyWork: {
    bodyWork: null,
    bodyWorkPhotos_1: null,
    bodyWorkPhotos_2: null,
    bodyWorkPhotos_3: null,
    accidentReport: null,
  },
  selectedPayment: null,
  appointmentSummary:null
};

function bookingReducer(state, action) {
  switch (action.type) {
    case "SET_ISTESLA":
      return { ...state, isTesla: action.isTesla };
    case "SET_SERVICEFLOWID":
      return { ...state, serviceFlowId: action.serviceFlowId };
    case "SET_SHOW_LIGHT_INDICATOR":
      return { ...state, showServiceLightIndicatorNeeded: action.showServiceLightIndicatorNeeded };
    case "SET_LOCK_STEPPER_NEXT":
      return { ...state, lockStepperNext: action.lockStepperNext };
    case "SET_AUTHORIZEDEV":
      return { ...state, isAuthorizedEV: action.isAuthorizedEV };
    case "SET_API_OPTIONS":
      return {
        ...state,
        apiOptions: action.value,
      };
    case "SET_STEP":
      return { ...state, step: action.step };
    case "SET_STEPSTATUS":
      return { ...state, stepStatus: action.stepStatus };
    case "TOGGLE_OPTION":
      return {
        ...state,
        options: {
          ...state.options,
          [action.option]: !state.options[action.option],
        },
      };
    case "SET_OPTION":
      return {
        ...state,
        options: {
          ...state.options,
          [action.option]: action.value,
        },
      };
    case "SET_OPTION_ELIGIBILITY":
      return {
        ...state,
        optionsEligibility: {
          ...state.optionsEligibility,
          [action.option]: action.value,
        },
      };
    case "SET_USERTOUCHED_CHECKBOXES":
      return { ...state, hasUsertouchedCheckboxes: action.hasUsertouchedCheckboxes };
    case "SET_CURRENT_MILLEAGE": {
      const inputMileage = action?.currentMilleage;

      if (!state.apiOptions) {
        return { ...state, currentMilleage: inputMileage };
      }
      
      if(state?.isTesla) {
        return {
          ...state,
          currentMilleage: inputMileage,
          optionsComputed: {
            bodyWork: computeOptionStatus({
              optionData: state?.apiOptions?.bodyWork,
              currentMileage: inputMileage,
              bodyWork:true,
            }),
          },
        };
      }

      return {
        ...state,
        currentMilleage: inputMileage,
        optionsComputed: {
          standarizedService: computeOptionStatus({
            optionData: state?.apiOptions?.standarizedService,
            currentMileage: inputMileage,
            standarizedService:true,
          }),
          tyresChange: computeOptionStatus({
            optionData: state?.apiOptions?.tyreChange,
            currentMileage: inputMileage,
            tyresChange:true,
          }),
          bodyWork: computeOptionStatus({
            optionData: state?.apiOptions?.bodyWork,
            currentMileage: inputMileage,
            bodyWork:true,
          }),
        },
      };
    }
    case "SET_MILEAGE_LIMITS":
      return {...state, mileageLimits: action.value };
    case "COMPUTE_OPTIONS_STATUS": {
      const { apiOptions, currentMileage } = action.payload;

      if(state?.isTesla) {
        return {
          ...state,
          optionsComputed: {
            bodyWork: computeOptionStatus({
              optionData: apiOptions.bodyWork,
              currentMileage,
              bodyWork:true,
            }),
          },
        };
      }

      return {
        ...state,
        optionsComputed: {
          standarizedService: computeOptionStatus({
            optionData: apiOptions.standarizedService,
            currentMileage,
            standarizedService:true,
          }),
          tyresChange: computeOptionStatus({
            optionData: apiOptions.tyreChange,
            currentMileage,
            tyresChange:true,
          }),
          bodyWork: computeOptionStatus({
            optionData: apiOptions.bodyWork,
            currentMileage,
            bodyWork:true,
          }),
        },
      };
    }
    case "SET_SERVICE_LIGHT_INDICATOR":
      return { ...state, serviceLightIndicator: action.serviceLightIndicator };
    case "SET_SELECTED_PICKUP":
      return { ...state, selectedPickup: action.selectedPickup };
    case "SET_STEP_TWO_AVAILABILITY":
      return { ...state, stepTwoAvailableAppointments: action.stepTwoAvailableAppointments };
    case "SET_STEPTHREE_OPTIONS":
      return {
        ...state,
        stepThreeOptions: {
          ...state.stepThreeOptions,
          [action.option]: action.value,
        },
      };
    case "SET_PICKUP_COST":
      return { ...state, pickupCost: action.pickupCost };
    case "SET_LOYALTY_COST":
      return { ...state, loyaltyCost: action.loyaltyCost };
    case "SET_STEP_THREE":
      return { ...state, stepThree: action.stepThree };
    case "SET_SHOW_INVOICE_OPTION":
      return { ...state, showInvoiceOption: action.showInvoiceOption };
    case "SET_HAS_SELECTED_INVOICE":
      return { ...state, hasSelectedInvoice: action.hasSelectedInvoice };
    case "SET_CALENDAR_DATA":
      return { ...state, calendarData: action.calendarData };
    case "SET_GARAGE_CALENDAR_DATA":
      return { ...state, garageCalendarData: action.garageCalendarData };
    case "SET_SELECTED_DATE":
      return {
        ...state,
        calendarValues: {
          ...state.calendarValues,
          selectedDate: action.value
        }
      };
    case "ADD_TIMESLOT": {
      return {
        ...state,
        calendarValues: {
          ...state.calendarValues,
          selectedSlots: [
            ...state.calendarValues.selectedSlots,
            action.value,
          ],
        },
      };
    }
    case "REMOVE_TIMESLOT": {
      return {
        ...state,
        calendarValues: {
          ...state.calendarValues,
          selectedSlots: state.calendarValues.selectedSlots.filter(
            s =>
              !(
                s.date === action.value.date &&
                s.start === action.value.start &&
                s.end === action.value.end
              )
          ),
        },
      };
    }
    case "CLEAR_TIMESLOTS": {
      return {
        ...state,
        calendarValues: {
          ...state.calendarValues,
          selectedSlots: []
        },
      };
    }
    case "SET_SELECTED_GARAGE":
      return { ...state, selectedGarage: action.selectedGarage };
    case "SET_PICKUP_ADDRESS":
      return {
        ...state,
        pickupCRMFormAddress: {
          ...state.pickupCRMFormAddress,
          [action.option]: action.value,
        },
      };
    case "SET_STANDARIZEDSERVICE":
      return {
        ...state,
        standarizedService: {
          ...state.standarizedService,
          [action.option]: action.value,
        },
      };
    case "SET_TYRESCHANGE":
      return {
        ...state,
        tyresChange: {
          ...state.tyresChange,
          [action.option]: action.value,
        },
      };
    case "SET_BODYWORK":
      return {
        ...state,
        bodyWork: {
          ...state.bodyWork,
          [action.option]: action.value,
        },
      };
    case "SET_SELECTED_PAYMENT":
      return { ...state, selectedPayment: action.selectedPayment };
    case "SET_SUMMARY":
      return { ...state, appointmentSummary: action.appointmentSummary };
    case "RESET_FIELDS": {
      const { fields } = action;

      return {
        ...state,
        ...fields.reduce((acc, field) => {
          if (field in initialState) {
            acc[field] = initialState[field];
          }
          return acc;
        }, {}),
      };
    }
    case "RESET_ADDRESS_STREET": {
      return {
        ...state,
        pickupCRMFormAddress: {
          ...state?.pickupCRMFormAddress,
          street:"",
          number:"",
          zipCode:"",
        },
      };
    }
    case "RESET":
      return initialState;
    default:
      return state;
  }
}

export function useBookingFlow() {
  const [state, dispatch] = useReducer(bookingReducer, initialState);
  return { state, dispatch };
}
